angular.module("boyds").directive('loadingSpinner', ['config', function (config) {
    return {
        restrict: 'E',
        scope: {
            isLoading: '=',
            isBig: '=?'
        },
        templateUrl: config.templates.loadingSpinner.url
    };
}]);